import { shopifyIntegrationActionTypes } from '../../actions/integrations/shopifyIntegrationActions';

const ShopifyIntegrationReducers = (state = { }, action) => {
  switch (action.type) {
  case shopifyIntegrationActionTypes.GET_SHOPIFY_CONNECTIONS.LOADING: {
    const { getShopifyConnectionsLoading } = action;
    return {
      ...state,
      getShopifyConnectionsLoading,
    };
  }
  case shopifyIntegrationActionTypes.GET_SHOPIFY_CONNECTIONS.SUCCESS: {
    const { shopifyConnections } = action;
    return {
      ...state,
      shopifyConnections,
    };
  }
  case shopifyIntegrationActionTypes.DELETE_SHOPIFY_CONNECTION.LOADING: {
    const { deleteShopifyConnectionLoading } = action;
    return {
      ...state,
      deleteShopifyConnectionLoading,
    };
  }

  case shopifyIntegrationActionTypes.CONNECT_TO_SHOPIFY.LOADING: {
    const { connectToShopifyLoading } = action;
    return {
      ...state,
      connectToShopifyLoading,
    };
  }

  case shopifyIntegrationActionTypes.CONNECT_TO_SHOPIFY.SUCCESS: {
    const { connectedToShopify } = action;
    return {
      ...state,
      connectedToShopify,
    };
  }

  case shopifyIntegrationActionTypes.CONNECT_TENANT_TO_SHOPIFY_LOCATION.LOADING: {
    const { connectTenantToShopifyLocationLoading } = action;
    return {
      ...state,
      connectTenantToShopifyLocationLoading,
    };
  }

  case shopifyIntegrationActionTypes.UPDATE_SHOPIFY_CONFIGURATION.LOADING: {
    const { updateShopifyConfigurationLoading } = action;
    return {
      ...state,
      updateShopifyConfigurationLoading,
    };
  }
  case shopifyIntegrationActionTypes.SYNC_SHOPIFY_INVENTORY.LOADING: {
    const { syncShopifyInventoryLoading } = action;
    return {
      ...state,
      syncShopifyInventoryLoading,
    };
  }
  case shopifyIntegrationActionTypes.SYNC_SHOPIFY_CUSTOMER.LOADING: {
    const { syncShopifyCustomerLoading } = action;
    return {
      ...state,
      syncShopifyCustomerLoading,
    };
  }
  case shopifyIntegrationActionTypes.SYNC_SHOPIFY_SO.LOADING: {
    const { syncShopifySOLoading } = action;
    return {
      ...state,
      syncShopifySOLoading,
    };
  }
  case shopifyIntegrationActionTypes.SYNC_SHOPIFY_ORDERS.LOADING: {
    const { syncShopifyOrdersLoading } = action;
    return {
      ...state,
      syncShopifyOrdersLoading,
    };
  }
  case shopifyIntegrationActionTypes.CANCEL_SHOPIFY_ORDER.LOADING: {
    const { cancelShopifyOrderLoading } = action;
    return {
      ...state,
      cancelShopifyOrderLoading,
    };
  }
  case shopifyIntegrationActionTypes.CREATE_ADHOC.LOADING: {
    const { createADHOCLoading } = action;
    return {
      ...state,
      createADHOCLoading,
    };
  }

  default: {
    return state;
  }
  }
};

export default ShopifyIntegrationReducers;
